import TableAttributeModel from "./TableAttributeModel";

interface ConstructorParams {
    name: { singular: string, plural: string };
    label: { singular: string, plural: string };
    apiPath: string;
    listPath?: string;       //  new field for listing path
    nextSnoPath?: string;    //  new field for next-sno path
    searchKey: TableAttributeModel;
    sortKey: TableAttributeModel;
    attributes: TableAttributeModel[];
    editable: boolean;
    deletable: boolean;    
}

export default class TableDataModel {
    name: { singular: string, plural: string };
    label: { singular: string, plural: string };
    apiPath: string;
    listPath: string;       //  will fallback to apiPath
    nextSnoPath: string;    //  will fallback to `${apiPath}/next-sno`
    searchAttribute: TableAttributeModel;
    sortAttribute: TableAttributeModel;
    attributes: TableAttributeModel[];
    editable: boolean;
    deletable: boolean;

    readonly primaryAttribute: TableAttributeModel | undefined;
    /** All key attributes (partition + sort key for composite-key tables). */
    readonly primaryAttributes: TableAttributeModel[];

    constructor({ name, label, apiPath, listPath, nextSnoPath, searchKey, sortKey, attributes, editable, deletable }: ConstructorParams) {
        this.name = name;
        this.label = label;
        this.apiPath = apiPath;
        this.listPath = listPath ?? apiPath;  //  fallback if not provided
        this.nextSnoPath = nextSnoPath ?? `${apiPath}/next-sno`; //  default

        this.searchAttribute = searchKey;
        this.sortAttribute = sortKey;
        this.attributes = attributes;
        this.editable = editable;
        this.deletable = deletable;
        this.primaryAttributes = this.attributes.filter(attribute => attribute.primary);
        this.primaryAttribute = this.primaryAttributes[0];

        if (!this.primaryAttribute) {
            throw new Error(`Table ${this.name.singular} does not have a primary key`);
        }
    }
}
